import { makeAutoObservable } from 'mobx'

export enum TYPE_MESSAGE_POPUP {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export class MessageStore {
  text: string | null = null

  type: TYPE_MESSAGE_POPUP = TYPE_MESSAGE_POPUP.SUCCESS

  get isActivated() {
    return this.text != null
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  private _hideTimerId: ReturnType<typeof setTimeout> = null

  show({
    text,
    type = TYPE_MESSAGE_POPUP.SUCCESS,
    time,
  }: {
    text: string
    type?: TYPE_MESSAGE_POPUP
    time?: number
  }) {
    if (this._hideTimerId != null) {
      clearTimeout(this._hideTimerId)
    }

    this.text = text
    this.type = type

    if (time != null) {
      this._hideTimerId = setTimeout(this.hide.bind(this), time)
    }
  }

  hide() {
    if (this._hideTimerId != null) {
      clearTimeout(this._hideTimerId)
    }

    this.text = null
    this.type = TYPE_MESSAGE_POPUP.SUCCESS
  }
}
